var _style, _g, _circle, _defs, _g2, _defs2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 447.6 447.6",
    style: {
      enableBackground: "new 0 0 447.6 447.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#009FE3;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{fill:#E5A10A;}\n\t.st3{fill:#EE7AAA;}\n\t.st4{fill:#E3B271;}\n\t.st5{fill:#F5C586;}\n\t.st6{opacity:0.7;fill:#E5A10A;}\n\t.st7{opacity:0.7;fill:#EE7AAA;}\n\t.st8{opacity:0.7;fill:#E3B271;}\n\t.st9{opacity:0.7;fill:#F5C586;}\n\t.st10{clip-path:url(#SVGID_4_);}\n\t.st11{fill:#378292;}\n\t.st12{fill:#343434;}\n\t.st13{opacity:0.7;fill:none;}\n\t.st14{opacity:0.7;fill:#378292;}\n\t.st15{opacity:0.7;fill:#343434;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 223.8,
    cy: 223.8,
    r: 223.8
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 223.8,
    cy: 223.8,
    r: 223.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M367.8,114.5c0,0-9.7-29.9-52.9-20.2c-43.2,9.7-63.7,52.8-51.7,77.6c0,0-35.1,85.4,22.2,120.3 c0,0-29.1-36.2-5.3-69c23.8-32.7,41.2,80.4,13.7,101.8l106.6,5.7c0,0,2-30.3-11.3-45.6c0,0,12.9,10.3,29.1,7.2 c0,0-11.7-2.2-17-22.3c0,0,8.9,12.3,27.5,9.5c0,0-27.5-12.1-19-36.4c8.5-24.2,8.5-81.6-6.5-103.4 C388.4,117.7,377.1,111.2,367.8,114.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M459.7,389.2V356c0-24-16.4-43.4-36.6-43.4H245.5c-20.2,0-36.6,19.4-36.6,43.4v33.2H459.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M363,337.7c0,0-1.6,21.3-28.7,21.3c-27.2,0-28.7-21.3-28.7-21.3v-61.6H363V337.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M389.2,235.8c0,31.1-25.2,56.3-56.3,56.3l0,0c-31.1,0-56.3-25.2-56.3-56.3v-63 c0-31.1,25.2-56.3,56.3-56.3l0,0c31.1,0,56.3,25.2,56.3,56.3V235.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M276.7,200.1c0,0,7.9-48.5,33.4-55.7c0,0,13.4,60.9,52.9,59.9c0,0,4,75.4,46.8,84.7c0,0-38.4-16.2-39.6-82 c0,0,1.2,37.3,15.9,47.2c0,0,23.7-90-9-123.9c-32.7-33.9-33.9-28.7-63-18.2C285,122.5,259.8,162.1,276.7,200.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M305.5,302c-0.8,3.9-1.9,7.5-3.2,10.7h3.2V302z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M263.2,171.8c0,0-35.1,85.4,22.2,120.3c0,0-25.9-32.3-8.7-63.4v-28.5c0,0,7.9-48.5,33.4-55.7 c0,0,6.2,28,22.5,45.7v-73.6v-11.1V92.3c-5.1-0.1-11,0.4-17.6,1.9C271.7,103.9,251.2,147,263.2,171.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M305.5,337.7v-25h-3.2h-56.8c-20.2,0-36.6,19.4-36.6,43.4v33.2h123.7v-30.3 C307.1,358,305.5,337.7,305.5,337.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M305.5,284.9v17v10.7v25c0,0,1.5,20.4,27,21.3v-32v-14.3v-20.6C322.7,292,313.5,289.4,305.5,284.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M276.7,200.1v28.5v7.2c0,21.1,11.6,39.5,28.9,49.1c8,4.5,17.2,7.1,27,7.1v-16v-86 c-16.3-17.7-22.5-45.7-22.5-45.7C284.6,151.6,276.7,200.1,276.7,200.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.9,
    y: 389.2,
    className: "st3",
    width: 250.8,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.9,
    y: 389.2,
    className: "st7",
    width: 123.7,
    height: 64.2
  }))))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_3_",
    cx: 223.8,
    cy: 223.8,
    r: 223.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M179,212.9c0,6.4,5.2,11.6,11.6,11.6l0,0c6.4,0,11.6-5.2,11.6-11.6v-22.1c0-6.4-5.2-11.6-11.6-11.6l0,0 c-6.4,0-11.6,5.2-11.6,11.6V212.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M57.6,212.9c0,6.4,5.2,11.6,11.6,11.6l0,0c6.4,0,11.6-5.2,11.6-11.6v-22.1c0-6.4-5.2-11.6-11.6-11.6l0,0 c-6.4,0-11.6,5.2-11.6,11.6V212.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M-5,388.7V353c0-25.8,17.6-46.7,39.4-46.7h191c21.8,0,39.4,20.9,39.4,46.7v35.7H-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M80.8,318.7c0,0,16.1,18.3,49.1,18.3c33,0,49.1-18.3,49.1-18.3V253H80.8V318.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M69.3,235.7c0,33.4,27.1,60.5,60.5,60.5l0,0c33.4,0,60.5-27.1,60.5-60.5v-67.8c0-33.4-27.1-60.5-60.5-60.5 l0,0c-33.4,0-60.5,27.1-60.5,60.5V235.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M129.9,102.9c0,0,67.2-8.4,67.2,78.4c0,0-2.2-2-6.5-2l-0.1,20.2h-3.3c0,0,1.6-71.2-31.1-74.4 c0,0-5.1,7-26.1,7c-21,0-26.1-7-26.1-7c-32.7,3.2-31.1,74.4-31.1,74.4h-3.3l-0.1-20.2c-4.3,0-6.5,2-6.5,2 C62.7,94.5,129.9,102.9,129.9,102.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M62.7,181.2c1.5-1,3.3-1.7,5.3-1.9C64.5,179.6,62.7,181.2,62.7,181.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M69.2,179.2c-0.4,0-0.9,0-1.3,0.1c-1.9,0.2-3.7,0.9-5.3,1.9l0,0l0,0c-3.1,2.1-5.1,5.6-5.1,9.6v22.1 c0,6.4,5.2,11.6,11.6,11.6c0,0,0.1,0,0.1,0v-25.1L69.2,179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M80.8,318.7v-12.3H34.4C12.6,306.3-5,327.2-5,353v35.7h132.7v-51.7C96.2,336.2,80.8,318.7,80.8,318.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M80.8,271.2v35.1v12.3c0,0,15.4,17.5,46.9,18.2v-30.6v-10.1C108.4,295.6,91.4,285.8,80.8,271.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M103.7,124.9c-32.7,3.2-31.1,74.4-31.1,74.4h-3.3v25.1v11.3c0,13.2,4.3,25.5,11.5,35.4 c10.6,14.7,27.6,24.4,46.9,25.1V253V131.9C108.5,131.4,103.7,124.9,103.7,124.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M62.7,181.2L62.7,181.2L62.7,181.2c0,0,1.8-1.6,5.3-1.9c0.4,0,0.8-0.1,1.3-0.1l0.1,20.2h3.3 c0,0-1.6-71.2,31.1-74.4c0,0,4.8,6.5,24,6.9v-24.4v-4.7C116.2,102.2,62.7,103.8,62.7,181.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5.1,
    y: 388.7,
    className: "st11",
    width: 269.9,
    height: 65.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: 388.7,
    className: "st14",
    width: 132.7,
    height: 65.2
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.e0db13a16d0856eb35bb3b052711114a.svg";
export { ForwardRef as ReactComponent };